// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Dialog_dialog__UkYPS","entered":"Dialog_entered__jiJUN","dialog-inner":"Dialog_dialog-inner__xP7HZ","exiting":"Dialog_exiting__nC38k"};